export const ObjectTypesArray = [
  "Karton",
  "Bigbag",
  "Paleta EUR",
  "Paleta EUR 1/2",
  "Inna paleta",
  "Inne",
];
export const ServicesTypesArray = [
  "Składowanie",
  "Crossdocking",
  "Fullfilment",
  "Etykietowanie",
  "Pakowanie",
  "Sortowanie",
  "E-commerce",
  "Wysyłka",
  "Inne",
  "Przyjęcie towaru",
  "Wydanie towaru",
];
